// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__8Z6ZW","tab":"Tabs_tab__jFOqL","tab-active":"Tabs_tab-active__0vMVq"};